module.exports = __webpack_public_path__ + "img/Color 209.2c4bcee1.jpg";